import './parallax.component.scss'

import SimpleParallax from 'simple-parallax-js'

document.querySelectorAll('.parallax').forEach((root) => {
  new SimpleParallax(root.querySelector('img'))
})
